import React, { useEffect, useState } from 'react';
import { useFormContext } from '../context/FormContext';
import { useHistory } from 'react-router-dom';
import { MdArrowForward } from 'react-icons/md';
import Session from './auth/Session';

const Home = () => {
    const [selected, setSelected] = useState(null);
    const history = useHistory();

    const { resetForm } = useFormContext();

    useEffect(() => {
        async function checkPolicyRedirect() {
            const token = Session.getToken();
            if (!token) return;

            const roles = Session.getRole() || '';
            if (roles.includes('Admin') || roles.includes('CSR')) {
                history.push('/data/dashboard');
            };

            const email = Session.getUserName();
            if (!email) return;

            try {
                const response = await fetch(
                    `api/Quote/HasActivePolicy?email=${encodeURIComponent(email)}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const result = await response.json();
                if (result.hasActivePolicy) {
                    history.push('/dashboard');
                }
            } catch (err) {
                console.error('Policy check failed:', err);
            }
        }

        checkPolicyRedirect();
    }, []);

    const handleContinue = () => {
        if (selected === 'quote'){
            // wipe session. Start fresh
            resetForm();
            history.push('/signup/eligibility');
        }
        if (selected === 'existing') history.push('/find-quote');
    };

    const options = [
        {
            id: 'quote',
            title: 'Request a quote',
            description: 'Get coverage for your property',
        },
        {
            id: 'existing',
            title: 'Continue existing quote',
            description: 'Resume your saved application',
        },
    ];

    return (
        <div className="page-centered" style={{ flexDirection: 'column', gap: 'var(--space-xl)' }}>
            <div className="" style={{ width: '100%', maxWidth: '580px' }}>

                {/* Heading */}
                <div style={{ marginBottom: 'var(--space-lg)' }}>
                    <h3 className="h3" style={{fontSize: '2rem'}}>Start your quote</h3>
                    <p className="body" style={{ margin: 0 }}>
                        Elevana Solutions helps you secure parametric hurricane insurance for when a storm impacts your area.
                    </p>
                </div>

                {/* Option cards */}
                {options.map((option) => {
                    const isSelected = selected === option.id;
                    return (
                        <div
                            key={option.id}
                            className="card"
                            onClick={() => setSelected(option.id)}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 'var(--space-md)',
                                marginBottom: 'var(--space-lg)',
                                cursor: 'pointer',
                                borderColor: isSelected ? 'var(--border-selected)' : 'var(--border-subtle-color)',
                                background: isSelected ? '#ECF4F3' : 'var(--color-white)',
                                transition: 'all var(--duration-200) var(--ease-standard)',
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => setSelected(option.id)}
                                style={{ accentColor: 'var(--brand-primary)', width: 18, height: 18, flexShrink: 0 }}
                            />
                            <div>
                                <p className="h5" style={{ margin: 0, fontWeight: 'var(--weight-semibold)' }}>
                                    {option.title}
                                </p>
                                <p className="small" style={{ margin: 0 }}>
                                    {option.description}
                                </p>
                            </div>
                        </div>
                    );
                })}

                {/* Continue button */}
                <div style={{ marginTop: 'var(--space-lg)' }}>
                    <button
                        className="btn"
                        disabled={!selected}
                        onClick={handleContinue}
                        style={{ width: '100%' }}
                    >
                        Continue <MdArrowForward size={16} />
                    </button>
                </div>

                {/* Footer links */}
                <div style={{ textAlign: 'center', marginTop: 'var(--space-lg)' }}>
                    <p className="small" style={{ margin: '0 0 var(--space-xs)' }}>
                        Already have an account?
                        <br />
                        <a href="/login" className="auth-link">Access your member portal</a>
                    </p>
                    <p className="small" style={{ margin: 0, marginTop: 'var(--space-md)' }}>
                        Questions? Call us at <a href="tel:8772695422">877-269-5422</a> to connect.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default Home;